<template>
  <router-view />
</template>

<script>
export default {
  name: 'App',
  data: function () {
    return {
    }
  },
  methods: {
  }
}
</script>

<style>
  body{
    font-family: 'Lato', sans-serif;
    font-weight: 400;
    background: #F2EFEF;
  }
  h1{
    font-weight: 700;
    font-size: 3rem;
    color: #D35A56;
  }
  h2{
    font-weight: 700;
  }
  h3{
    font-weight: 700;
    font-size: 1.2rem;
  }
.router-link-active{
  color: #F2EFEF;
}
.btn-round{
  background: linear-gradient(to bottom, #90c688 0%,#61933e 100%);
  border: none;
  border-radius: 20px;
  padding-right: 3em;
  padding-left: 3em;
  font-size: 1.2em;
}
.btn-black{
  background: #000;
}
.btn-green{
  background: #88B87C;
}
.btn-red{
  background: #D35A56;
}
</style>



// WEBPACK FOOTER //
// src/App.vue